import { Slider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import React from 'react'

interface VmSliderProps {
  label?: string
  tooltipText?: string
  min?: number
  max?: number
  value: number
  onChange: (value: number) => void
  className?: string
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  sliderRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  slider: {
    flexGrow: 1,
    margin: `0 ${theme.spacing(2)}px`,
    // width: 320,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  inputBox: {
    width: 20,
    textAlign: 'center',
  },
  minMaxLabel: {
    minWidth: 50,
    textAlign: 'center',
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#0089C7',
    border: '4px solid white',
    boxShadow: '0 0 0 2px #0089C7',
    boxSizing: 'border-box',
    marginTop: -8, // <-- tweak this depending on track height
    '&:hover, &.Mui-focusVisible, &.Mui-active': {
      boxShadow: '0 0 0 1px #0089C7',
    },
  },
  track: {
    backgroundColor: '#0089C7',
    height: 4,
    borderRadius: 2,
  },
  rail: {
    backgroundColor: '#E6E6EA',
    height: 4,
    borderRadius: 2,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 36,
    padding: '0 8px',
    borderRadius: 4,
    border: `1px solid ${theme.components.iconButton.border}`,
    backgroundColor: theme.components.iconButton.background,
    color: theme.components.iconButton.color,
    cursor: 'pointer',
    fontSize: 14,
  },
  subContainer: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}))

const VmSlider: React.FC<VmSliderProps> = ({ min = 1, max = 20, value, onChange, className }) => {
  const classes = useStyles()

  const handleSliderChange = (_, newValue: number | number[]) => {
    onChange(newValue as number)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = Number(e.target.value)
    if (!isNaN(val) && val >= min && val <= max) {
      onChange(val)
    }
  }

  return (
    <div className={clsx(classes.container, className)}>
      <div className={classes.sliderRow}>
        <Text variant="body2" className={classes.minMaxLabel}>
          {min} VM
        </Text>
        <Slider
          className={classes.slider}
          value={value}
          onChange={handleSliderChange}
          min={min}
          max={max}
          step={1}
          valueLabelDisplay="off"
          color="primary"
          //   classes={{ thumb: classes.thumb }}
          classes={{
            root: classes.slider,
            thumb: classes.thumb,
            track: classes.track,
            rail: classes.rail,
          }}
        />
        <Text variant="body2" className={classes.minMaxLabel}>
          {max} VMs
        </Text>
        <button className={classes.button}>{value}</button>{' '}
        <Text variant="body2" className={classes.minMaxLabel}>
          VMs
        </Text>
      </div>
    </div>
  )
}

export default VmSlider
